import React from 'react';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import type { IJobInfoCardsProps } from '../../interfaces';

export const JobInfoCards = ({ keyInfo }: IJobInfoCardsProps) => (
  <Grid container spacing={1.5}>
    {keyInfo.map((item) => {
      const accent = item.accent ?? 'primary';
      return (
        <Grid item xs={12} md={6} key={item.key}>
          <Card elevation={0} sx={{ border: 1, borderColor: 'divider' }}>
            <CardContent sx={{ p: 1.5, '&:last-child': { pb: 1.5 } }}>
              <Stack direction="row" spacing={1.5} alignItems="center">
                <Avatar variant="rounded" sx={{ bgcolor: `${accent}.50`, color: `${accent}.main`, width: 36, height: 36 }}>
                  {item.icon}
                </Avatar>
              <Box sx={{ minWidth: 0 }}>
                <Typography variant="caption" color="text.secondary" fontWeight={600}>
                  {item.label}
                </Typography>
                <Typography
                  variant={item.key === 'timeline' ? 'caption' : 'body2'}
                  fontWeight={700}
                  noWrap
                >
                  {item.value}
                </Typography>
              </Box>
            </Stack>
          </CardContent>
        </Card>
      </Grid>
      );
    })}
  </Grid>
);
